// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import React from 'react'
import { alphaSort } from '../../../common/utils'
import { i18n } from '../../index'
import VitrineProductRow from './VitrineProductRow'
import css from './vitrineProductTable.css'
import type { VitrineProduct } from './vitrineProductTypes'
type Props = {
  data: Array<VitrineProduct>
  onEdit: (...args: Array<any>) => any
}

class VitrineProductTable extends React.PureComponent<Props> {
  render() {
    const { data, onEdit } = this.props

    const sortProducts = (products) => {
      const sortedCommonProducts = alphaSort(
        'name',
        products.filter((p) => !p.station),
      )
      const sortedStationsProducts = alphaSort(
        'name',
        products.filter((p) => p.station),
      )
      return [...sortedCommonProducts, ...sortedStationsProducts]
    }

    return (
      <div className={css.component}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell className={css.tableHeading}>{i18n.t('admin.vitrineProducts.products.label.name')}</TableCell>
              <TableCell className={css.tableHeading} padding='checkbox'>
                {i18n.t('admin.vitrineProducts.products.label.global')}
              </TableCell>
              <TableCell className={css.tableHeading} />
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length ? (
              sortProducts(data).map((vitrineProduct, i) => (
                <VitrineProductRow data={vitrineProduct} onEdit={onEdit} key={i} />
              ))
            ) : (
              <TableRow>
                <TableCell>{i18n.t('admin.vitrineProducts.products.noProducts')}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default VitrineProductTable
